<template>
    <ul>
        <div class="xc-tree-group" v-for="item in data" :key="item.treeId" @click.stop="groupClick($event,item)">
            <div class="xc-tree-item" :id="item.treeId"  @mouseover="item.isHover=true" @mouseout="item.isHover=false" @contextmenu.prevent="rightShow($event,item)" :class="{'highlight':item.isHover}" :style="{marginLeft:-25*item.level+'px',paddingLeft:25*item.level+'px'}">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAIVBMVEUAAABZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVmK4m3UAAAACnRSTlMAxpk6Ggfm5WdmRpz/IwAAACZJREFUCNdjoA5QRTAXOsCZq4oRzFUTEMwFCGYDnJmMzQRVShwFAAomCeMM46k9AAAAAElFTkSuQmCC"
                     v-show="item.expand==false && item.children.length>0" class="folder" @click="switchTree(item)"/>

                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAG1BMVEUAAABZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVm+HhmTAAAACHRSTlMA5sabZTkaBsj8rOQAAAAoSURBVAjXY6AhsOjo6DCAMIs6OpoKIEw2iQ4xmIqIjgAYk6WF6vYDAP2qBum5iCfkAAAAAElFTkSuQmCC"
                     v-show="item.expand==true && item.children.length>0" class="folder" @click="switchTree(item)"/>

                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAIVBMVEUAAABZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVmK4m3UAAAACnRSTlMAxpk6Ggfm5WdmRpz/IwAAACZJREFUCNdjoA5QRTAXOsCZq4oRzFUTEMwFCGYDnJmMzQRVShwFAAomCeMM46k9AAAAAElFTkSuQmCC"
                     v-show="item.children.length==0" class="folder" :style="{opacity:0}" style="cursor: default"/>
                <input type="checkbox" class="xc-checkbox" :class="{'xc-input-disabled':item.disabled}" name="input" v-show="showCheckbox" :checked="item.checked" :disabled="item.disabled" :indeterminate="item.indeterminate"
                       :value="item.treeId" @click.stop="updateBox(item,$event)" v-if="multiple"/>
                <input type="radio" class="xc-checkbox" :class="{'xc-input-disabled':item.disabled}" name="inputRadio" v-show="showCheckbox" :checked="item.checked" :disabled="item.disabled"
                       :value="item.treeId" @click.stop="update(item,$event)" :key="item.checked" v-else/>
                <div class="xc-tree-item-content" >
                    <span class="xc-text" @click="clickText(item,$event)" :class="{'active':item.active}">{{item[label]}}</span>
                </div>
            </div>
            <template v-if="item.children.length>0">
                <tree-group :origin="origin" :data="item.children" :label="label" :parent="item" :type="type" :indeterminate="indeterminate" :hasChecked="hasChecked" :showCheckbox="showCheckbox"
                            :expand="expand" :selectText="selectText" :checkedBox="checkedBox" :multiple="multiple"
                            :linked="linked" :updateData="updateData" :rightClick="rightClick" :nodeClick="nodeClick" v-show="item.expand"
                            @check="handleParent"></tree-group>
            </template>
        </div>
    </ul>
</template>

<script>

    export default {
        name: "TreeGroup",
        data() {
            return {
                current: {},
            }
        },
        computed: {},
        props: {
            origin:{
                type:Array,
                default:() => {
                    return [];
                },
            },
            data: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            label:{
                type:String,
                default:"",
            },
            parent: {
                type: Object,
                default: null,
            },
            hasChecked: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            updateData: {
                type: Function,
                default: function () {

                }
            },
            showCheckbox: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            linked: {
                type: Boolean,
                default: false,
            },
            //    半选是否表示选中
            indeterminate:{
                type:Boolean,
                default:false
            },
            //模式
            type:{
                type:Number,
                default:0,
            },
            expand: {
                type: Function,
                default: function () {

                }
            },
            selectText: {
                type: Function,
                default: function () {

                }
            },
            checkedBox: {
                type: Function,
                default: function () {

                }
            },
            rightClick:{
                type:Function,
                default:function () {

                }
            },
            nodeClick:{
                type:Function,
                default:function () {

                }
            }
        },
        methods: {
            //右键事件
            rightShow(e,item){
                if(this.showCheckbox){
                    return;
                }
                this.handleData(this.origin);
                item.active=true;
                var data={
                    event:e,
                    data:item
                }
                this.rightClick(data)
            },
            groupClick(e,item){
                //    选中效果
                this.handleData(this.origin);
                item.active=true;
                this.nodeClick(item)
            },
            //处理数组
            handleData: function (arr) {
                if (arr.length > 0) {
                    //    遍历所有节点
                    for (let x of arr) {
                        x.active=false;
                        this.handleData(x.children)
                    }
                } else {
                    return;
                }
            },
            //是否在hasChecked里面
            hasOwn: function (item) {
                return this.hasChecked.some(function (obj) {
                    return obj.treeId == item.treeId;
                })
            },
            //点击折叠
            switchTree(item){
                //折叠
                if(item.expand){
                    item.expand=false;
                }else {
                    item.expand=true;
                }
                this.expand(item);
            },
            //    点击文字
            clickText: function (item, e) {
                //    选中效果
                this.handleData(this.origin);
                item.active=true;
                this.selectText(item);
            },
            //    点击单选框
            update: function (item, e) {
                if (this.hasOwn(item)) {
                    item.checked = false;
                } else {
                    //上一个已选项的checked变成false
                    if (this.hasChecked[0]) {
                        this.hasChecked[0].checked = false;
                    }
                    item.checked = true
                }
                this.checkedBox(item);
            },
            //    点击复选框
            updateBox: function (item, e) {
                // console.log(this.indeterminate);
                var checked = e.target.checked;
                item.indeterminate=null;
                if (checked) {
                    //选中
                    item.checked = true;
                    //孩子全部选中
                    this.cycleData(item.children, true);
                    if (this.parent) {
                        //选中所有父级
                        this.$emit("check", {treeParentId: item.treeParentId, checked: true})
                    }
                } else {
                    //    取消选中
                    item.checked = false;
                    this.cycleData(item.children, false);
                    this.$emit("check", {treeParentId: item.treeParentId, checked: false})
                }
                this.checkedBox(item);
            },
            //    遍历孩子
            cycleData: function (arr, value) {
                if (arr.length > 0) {
                    for (let x of arr) {
                        x.checked = value;
                        x.indeterminate=null;
                        this.cycleData(x.children, value)
                    }
                }
                return arr;
            },
            //判断该节点的孩子中是否有未选中,若有返回true
            noChecked:function(data){
                if(data.children.length){
                    for(let x of data.children){
                        if(x.checked==true){
                            var result = this.noChecked(x);
                            if(result){
                                return result;
                            }
                        }else {
                            return true;
                        }
                    }
                }else {
                    return false;
                }
            },
            //判断该节点的孩子中是否有选中，若有返回true
            allChecked:function(data){
                if(data.children.length){
                    for(let x of data.children){
                        if(x.checked==true){
                            return true;
                        }else {
                            var result=this.allChecked(x);
                            if(result){
                                return result;
                            }
                        }
                    }
                }else {
                    return false;
                }
            },
            //    处理父级节点
            handleParent: function (data) {
                if (data.checked) {
                    if(this.linked){
                        //联动
                        for (let x of this.data) {
                            if (x.treeId == data.treeParentId) {
                                if(this.type==1){
                                //    特殊模式，孩子选中父亲不选中
                                    x.indeterminate="indeterminate";
                                }else {
                                    //是否存在未选中
                                    var all=this.noChecked(x);
                                    // console.log("all",all)
                                    if(all){
                                        //未全部选中
                                        x.indeterminate="indeterminate";
                                        if(this.indeterminate){
                                            x.checked=true;
                                        }
                                    }else {
                                        //全部选中
                                        x.indeterminate=null;
                                        x.checked = true;
                                    }
                                }

                                if (this.parent) {
                                    this.$emit("check", {treeParentId: x.treeParentId, checked: true})
                                }
                                break;
                            }
                        }
                    }else {
                    //    不联动

                    }
                } else {
                    if (this.linked) {
                        //    联动
                        for (let x of this.data) {
                            if (x.treeId == data.treeParentId) {
                                //是否存在选中的孩子
                                var all=this.allChecked(x);
                                if(all){
                                //    存在选中的孩子
                                    x.indeterminate="indeterminate";
                                    if(this.indeterminate){
                                        x.checked=true;
                                    }else {
                                        x.checked=false;
                                    }
                                }else {
                                    x.indeterminate=null;
                                    x.checked=false;
                                }
                                this.$emit("check", {treeParentId: x.treeParentId, checked: false});
                                break;
                            }
                        }
                    }else {
                    //不联动

                    }
                }
            },

        },
        mounted() {

        },
        created() {

        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/variable.scss";

    .xc-tree-group { // 取消文字选中效果
        -moz-user-select:none;/*火狐*/
        -webkit-user-select:none;/*webkit浏览器*/
        -ms-user-select:none;/*IE10*/
        -khtml-user-select:none;/*早期浏览器*/
        user-select:none;
        .xc-tree-item {
            /*height: 20px;*/
            width: max-content;
            min-width: 100%;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            &.highlight{
                background: #f1f1f1;
            }
            img {
                cursor: pointer;
                margin-right: 3px;
                &.folder{
                    /*width: 16px;*/
                    /*margin-left: 25px;*/
                }
            }
            .xc-checkbox{
                min-width: 14px;
                width: 14px;
                height: 14px;
            }
            .xc-tree-item-content{
                flex: 1;
                display: flex;
                align-items: center;
                .xc-text {
                    cursor: pointer;
                    font-size: 14px;
                    color: #6e7a90;
                    margin: 0 9px;
                    white-space: nowrap;
                    &.active{
                        color: $xc-bg;
                    }
                }
            }
        }
        ul {
            margin-left: 25px;
            .xc-tree-item{
                width: max-content;
                /*min-width: calc(100% + 25px);*/
                box-sizing: content-box;
                min-width: 100%;
                /*padding-left: 25px;
                margin-left: -25px;*/
            }
        }
    }
</style>
